import {Skeleton, Stack} from "@mui/material";

export function SidebarLoading() {
    return <>
        <Stack sx={{height: 34, width: 108, pl: '4px'}} direction="row"
               alignItems={'center'}
               className="goldern-record-cluster-type-button-group">
            {/* <Skeleton width={134} height={30}/> */}
            <Skeleton width={124} height={28}/>
        </Stack>

        <Skeleton sx={{marginTop: '8px'}} width={232} height={40}/>
        <Skeleton sx={{marginTop: '24px'}} width={232} height={20}/>
        <Stack gap={'4px'} sx={{marginTop: '12px'}}>
            <Skeleton width={232} height={50}/>
            <Skeleton width={232} height={50}/>
            <Skeleton width={232} height={50}/>
            <Skeleton width={232} height={50}/>
            <Skeleton width={232} height={50}/>
            <Skeleton width={232} height={50}/>
            <Skeleton width={232} height={50}/>
            <Skeleton width={232} height={50}/>
            <Skeleton width={232} height={50}/>
            <Skeleton width={232} height={50}/>
            <Skeleton width={232} height={50}/>
            <Skeleton width={232} height={50}/>
        </Stack>
    </>
}
